import React from "react";
import { store } from "./app/store";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Overview from "./pages/Overview";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import ProtectedRoute from "./components/ProtectedRoute";

// Admin pages
import AgentOperations from "./pages/admin/AgentOperations";
import AgentScheduler from "./pages/admin/AgentScheduler";
import BiDashboard from "./pages/admin/BIDashboard";
import AgentAnalytics from "./pages/admin/AgentAnalytics";
import IssueAnalytics from "./pages/admin/IssueAnalytics";
import ScanTemplatesV2 from "./pages/admin/ScanTemplatesV2";
import CostAnalytics from "./pages/admin/CostAnalytics";
import CustomerAnalytics from "./pages/admin/CustomerAnalytics";
import CustomerActions from "./pages/admin/CustomerActions";
import ScopeSelectionTracker from "./pages/admin/ScopeSelectionTracker";
import TeamUsage from "./pages/admin/TeamUsage";
import AgentMemory from "./pages/admin/AgentMemory";
import ControlTower from "./pages/admin/ControlTower";
import ControlTowerRunDetail from "./pages/admin/ControlTower/RunDetail";
import EvalResults from "./pages/admin/EvalResults";
import EvalRunDetail from "./pages/admin/EvalResults/RunDetail";

// Setup pages
import WebsiteParameters from "./pages/setup/WebsiteParameters";

// Common components for different environments
import { ENVIRONMENTS, default as ScansByEnvironment } from "./pages/common/ScansByEnvironment";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          {/* Public route for login */}
          <Route path='/login' element={<Login />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/reset-password' element={<ResetPassword />} />

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              {/* Home page */}
              <Route path='/' element={<Overview />} />

              {/* Admin routes */}
              <Route path='/admin/bi-dashboard' element={<BiDashboard />} />
              <Route path='/admin/agent-operations' element={<AgentOperations />} />
              <Route path='/admin/agent-scheduler' element={<AgentScheduler />} />
              {/* Legacy path → Agent Operations (replaced Acquisition Pipeline) */}
              <Route
                path='/admin/acquisition-tools-v2'
                element={<Navigate to='/admin/agent-operations' replace />}
              />
              <Route path='/admin/agent-analytics' element={<AgentAnalytics />} />
              <Route path='/admin/issue-analytics' element={<IssueAnalytics />} />
              <Route path='/admin/scan-templates-v2' element={<ScanTemplatesV2 />} />
              <Route path='/admin/cost-analytics' element={<CostAnalytics />} />
              <Route path='/admin/customer-analytics' element={<CustomerAnalytics />} />
              <Route path='/admin/customer-actions' element={<CustomerActions />} />
              <Route path='/admin/scope-selection-tracker' element={<ScopeSelectionTracker />} />
              <Route path='/admin/team-usage' element={<TeamUsage />} />
              <Route path='/admin/agent-memory' element={<AgentMemory />} />
              <Route path='/admin/control-tower' element={<ControlTower />} />
              <Route path='/admin/control-tower/:env/:runId' element={<ControlTowerRunDetail />} />
              <Route path='/admin/eval-results' element={<EvalResults />} />
              <Route path='/admin/eval-results/runs/:runId' element={<EvalRunDetail />} />

              {/* Setup routes */}
              <Route path='/setup/website-parameters' element={<WebsiteParameters />} />

              {/* Platform routes - using the unified components with appropriate environment */}
              <Route
                path='/platform/staging-scans'
                element={<ScansByEnvironment environment={ENVIRONMENTS.STAGING} />}
              />
              <Route
                path='/platform/prod-scans'
                element={<ScansByEnvironment environment={ENVIRONMENTS.PRODUCTION} />}
              />

              {/* Catch-all redirect to home */}
              <Route path='*' element={<Navigate to='/' replace />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
